// Spinner.jsx
import React from "react";
import PropTypes from "prop-types";
import "assets/css/Spinner.css";

const Spinner = ({ text = "Loading...", isActive = true }) => {
  if (!isActive) return null;

  return (
    <>
      <div className="overlay-backdrop"></div>
      <div className="overlay">
        <div className="spinner-border text-primary" role="status" />
        <p className="overlay-text">{text}</p>
      </div>
    </>
  );
};

Spinner.propTypes = {
  text: PropTypes.string,
  isActive: PropTypes.bool,
};

export default Spinner;
